// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__-1KZh"};